import { ArrayFilterPipe } from './../../pipes/array-filter/array-filter';
import { Component, NgModule} from '@angular/core';
import { NavController, ActionSheetController, ActionSheet} from 'ionic-angular';
import {HttpProvider} from '../../providers/http/HttpProvider';
import {Observable} from 'rxjs/Observable';
import { ToastController } from 'ionic-angular';
@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
  providers:[HttpProvider]
})
export class HomePage {
items: any;
categories: any;
filterCategory = 'lles';
toastShown = false;

  constructor(public navCtrl: NavController, private httpProvider:HttpProvider,public actionSheetCtrl: ActionSheetController,public toastCtrl: ToastController) {
    this.getdata();
    if(!this.toastShown)
    {
      this.presentToast();
    }
  } 
  presentToast() {
    let toast = this.toastCtrl.create({
      message: 'De prijzen en afbeeldingen kunnen afwijken van de werkelijkheid, de kassaprijs is ten alle tijden leidend.',
      duration: 20000,
       closeButtonText:"Oké",
       showCloseButton:true,
       dismissOnPageChange: this.toastShown = true
    });
    toast.present();
  }
  filterItems(category:string)
  {
    if(this.filterCategory == category)
    {
      this.filterCategory = 'lles';
    }
    else
    {
      this.filterCategory = category;
    }    
    this.getdata();
  }
createActionSheet()
{
  let actionSheet = this.actionSheetCtrl.create({
    title: 'Kies een categorie'
  });
this.items.forEach(element => {
  actionSheet.addButton({
    text:element.category, handler: () => {
      this.filterItems(element.category);
    let navTransition = actionSheet.dismiss();
    return false;
  }});
  
});
actionSheet.addButton({
  text:'Alles tonen', handler: () => {
  this.filterCategory = 'lles';
  this.getdata();
  let navTransition = actionSheet.dismiss();
  return false;
}})
actionSheet.present();
}

scrollTo(element:string) {
  //let yOffset = document.getElementById(element).offsetTop;
  this.scrollTo(element);
}
  getdata(){
    var dests = [];
    this.httpProvider.getJsonData('products')
    .subscribe(
      result => {
        let carsByDest = {};
  result.forEach((menuItem) => {
    if (!carsByDest[menuItem.category]) {
      carsByDest[menuItem.category] = [];
    }
    carsByDest[menuItem.category].push(menuItem);
  });
  for (let dest in carsByDest) {
    dests.push({category: dest, items: carsByDest[dest]});
    this.items = dests;
  }
        console.log("Success : " + result[0]['images'][0]['file']);
      },
      err =>{
        console.error("Error : "+err);
      } ,
      () => {
        console.log('getData completed');
      }
    );
    return dests;
  }
  
}


// WEBPACK FOOTER //
// ./src/pages/home/home.ts